// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3nH1Y","content":"LoadingAlert_content__37lnO"};